import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CancelPaymentComponent} from './cancel-payment.component';

@Injectable()
export class CancelPaymentService
{

    constructor(private modalService: NgbModal)
    {
    }

    public confirm(name: string, amount: string): Promise<Boolean>
    {
        const modalRef = this.modalService.open(CancelPaymentComponent, {
            size: 'lg',
            centered: true
        });
        modalRef.componentInstance.name = name;
        modalRef.componentInstance.amount = amount;

        return modalRef.result;
    }
}